<div class="profile-address-form general-container flex flex-col justify-center items-center h-full">

  <!-- ==================== STEP 1: Tipo + Ubicación ==================== -->
  <div *ngIf="step === 1" class="w-full">
    <div class="form-header header mb-24">
      <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px]">{{ 'PROFILE_ADDRESS_FORM.TITLE' | translate }}</h2>
      <p class="font-sans text-center text-xl text-gray-40">
        {{ 'PROFILE_ADDRESS_FORM.STEP_1.SUBTITLE' | translate }}
      </p>
    </div>

    <div class="form-body">
      <!-- Address Type Selector -->
      <div class="inp mb-32">
        <label class="block font-sans text-eggplant-80 text-l w-full mb-6">
          {{ 'PROFILE_ADDRESS_FORM.STEP_1.ADDRESS_TYPE_LABEL' | translate }}
        </label>
        <p class="font-sans text-eggplant-100/[0.5] text-s mb-8">
          {{ 'PROFILE_ADDRESS_FORM.STEP_1.ADDRESS_TYPE_HINT' | translate }}
        </p>
        <div class="address-type-grid grid grid-cols-2 md:grid-cols-3 gap-8">
          <div *ngFor="let type of addressTypes" class="form-input checkbox !mt-0 !mb-0">
            <input type="checkbox" [id]="'addressType_' + type.id" [checked]="isTypeSelected(type.id)"
              (change)="toggleType(type.id)">
            <label [for]="'addressType_' + type.id" class="!text-eggplant-100/[0.55]">{{ type.name }}</label>
          </div>
        </div>
        <p *ngIf="isSubmit && selectedTypes.length === 0" class="font-sans text-alert text-s mt-4">
          {{ 'PROFILE_ADDRESS_FORM.STEP_1.ADDRESS_TYPE_REQUIRED' | translate }}
        </p>
      </div>

      <!-- Country Toggle -->
      <div class="inp mb-16">
        <label class="block font-sans text-eggplant-80 text-l w-full mb-6">
          {{ 'PROFILE_ADDRESS_FORM.STEP_1.LOCATION_LABEL' | translate }}
        </label>
        <div class="flex flex-col gap-12">
          <div class="question cursor-pointer w-full flex gap-32 justify-between" (click)="toggleCountryType(true)"
            [ngClass]="{'option-selected': isNationalResidence, 'option': !isNationalResidence}">
            <div class="flex flex-col py-12 px-24 gap-4">
              <h4 class="font-sans text-xl text-eggplant-80">{{ 'PROFILE_ADDRESS_FORM.STEP_1.SPAIN' | translate }}</h4>
              <p class="font-sans text-l text-gray-40">{{ 'PROFILE_ADDRESS_FORM.STEP_1.SPAIN_DESC' | translate }}</p>
            </div>
          </div>
          <div class="question cursor-pointer w-full flex gap-32 justify-between" (click)="toggleCountryType(false)"
            [ngClass]="{'option-selected': !isNationalResidence, 'option': isNationalResidence}">
            <div class="flex flex-col py-12 px-24 gap-4">
              <h4 class="font-sans text-xl text-eggplant-80">{{ 'PROFILE_ADDRESS_FORM.STEP_1.INTERNATIONAL' | translate }}</h4>
              <p class="font-sans text-l text-gray-40">{{ 'PROFILE_ADDRESS_FORM.STEP_1.INTERNATIONAL_DESC' | translate }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Country Selector (International only) -->
      <div class="inp mb-16" *ngIf="!isNationalResidence">
        <fun-input *ngIf="!isMobile" [placeholder]="'PROFILE_ADDRESS_FORM.STEP_1.COUNTRY_PLACEHOLDER' | translate" [parentForm]="addressForm"
          [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit"
          controlName="country" type="select" [errorLogin]="errorAmount" [labelName]="'PROFILE_ADDRESS_FORM.STEP_1.COUNTRY_LABEL' | translate" [items]="countriesList"
          [selectedItem]="addressForm.get('country').value"></fun-input>
        <form *ngIf="isMobile" [formGroup]="addressForm">
          <div class="inp select form-input">
            <label class="block font-sans text-eggplant-80 text-l w-full mb-6">{{ 'PROFILE_ADDRESS_FORM.STEP_1.COUNTRY_LABEL' | translate }}</label>
            <select
              class="select-box w-full py-12 px-12 border border-eggplant-75 rounded bg-white font-sans text-eggplant-80"
              formControlName="country">
              <option hidden [value]="null">{{ 'PROFILE_ADDRESS_FORM.STEP_1.COUNTRY_PLACEHOLDER' | translate }}</option>
              <option *ngFor="let country of countriesList" [value]="country.id">
                {{ country.name }}
              </option>
            </select>
          </div>
        </form>
        <p *ngIf="isSubmit && !addressForm.get('country').value" class="font-sans text-alert text-s mt-4">
          {{ 'PROFILE_ADDRESS_FORM.REQUIRED_FIELD' | translate }}
        </p>
      </div>
    </div>
  </div>

  <!-- ==================== STEP 2: Formulario de dirección ==================== -->
  <div *ngIf="step === 2" class="w-full">
    <div class="form-header header mb-24">
      <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px]">{{ 'PROFILE_ADDRESS_FORM.TITLE' | translate }}</h2>
      <p class="font-sans text-center text-xl text-gray-40">
        {{ 'PROFILE_ADDRESS_FORM.STEP_2.SUBTITLE' | translate }}
      </p>
    </div>

    <div class="form-body">
      <!-- Autocomplete Mode (National only) -->
      <div *ngIf="isNationalResidence && autocompleteMode" class="mb-16">
        <div class="inp">
          <fun-input [placeholder]="'PROFILE_ADDRESS_FORM.STEP_2.ADDRESS_AUTOCOMPLETE_PLACEHOLDER' | translate" [parentForm]="addressForm"
            [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit"
            controlName="addressAutocomplete" [id]="'addressAutocomplete'" type="text" [errorLogin]="errorAmount"
            [labelName]="'PROFILE_ADDRESS_FORM.STEP_2.ADDRESS_LABEL' | translate" (addressPlaced)="getAddress($event)" [isDesktop]="desktopApp"></fun-input>
        </div>
        <p class="font-sans text-eggplant-100/[0.5] text-s mt-8">
          {{ 'PROFILE_ADDRESS_FORM.STEP_2.MANUAL_HINT' | translate }}
          <span class="text-orange-100 cursor-pointer underline" (click)="switchAutocomplete(false)">{{ 'PROFILE_ADDRESS_FORM.STEP_2.CLICK_HERE' | translate }}</span>
        </p>
      </div>

      <!-- Manual Mode -->
      <div *ngIf="!autocompleteMode || !isNationalResidence">
        <!-- Address Input -->
        <div class="inp mb-16">
          <fun-input [placeholder]="'PROFILE_ADDRESS_FORM.STEP_2.ADDRESS_MANUAL_PLACEHOLDER' | translate" [parentForm]="addressForm" [formControlKeys]="formControlKeys"
            [errorMessages]="errorMessages" [isSubmit]="isSubmit" controlName="address" type="text"
            [errorLogin]="errorAmount" [labelName]="'PROFILE_ADDRESS_FORM.STEP_2.ADDRESS_LABEL' | translate"></fun-input>
        </div>

        <!-- Postal Code -->
        <div class="inp mb-16">
          <fun-input [placeholder]="'PROFILE_ADDRESS_FORM.STEP_2.POSTAL_CODE_LABEL' | translate" [parentForm]="addressForm" [formControlKeys]="formControlKeys"
            [errorMessages]="errorMessages" [isSubmit]="isSubmit" controlName="postalCode" type="text"
            [errorLogin]="errorAmount" [labelName]="'PROFILE_ADDRESS_FORM.STEP_2.POSTAL_CODE_LABEL' | translate"></fun-input>
        </div>

        <!-- National: Region and City -->
        <div *ngIf="isNationalResidence">
          <div class="inp mb-16">
            <fun-input *ngIf="!isMobile" [placeholder]="'PROFILE_ADDRESS_FORM.STEP_2.PROVINCE_PLACEHOLDER' | translate" [parentForm]="addressForm"
              [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit"
              controlName="region" type="select" [errorLogin]="errorAmount" [labelName]="'PROFILE_ADDRESS_FORM.STEP_2.PROVINCE_LABEL' | translate"
              (selectChange)="onRegionChange()" [items]="regionList"
              [selectedItem]="addressForm.get('region').value"></fun-input>
            <form *ngIf="isMobile" [formGroup]="addressForm">
              <div class="inp select form-input">
                <label class="block font-sans text-eggplant-80 text-l w-full mb-6">{{ 'PROFILE_ADDRESS_FORM.STEP_2.PROVINCE_LABEL' | translate }}</label>
                <select
                  class="select-box w-full py-12 px-12 border border-eggplant-75 rounded bg-white font-sans text-eggplant-80"
                  formControlName="region" (change)="onRegionChange()">
                  <option hidden [value]="null">{{ 'PROFILE_ADDRESS_FORM.STEP_2.PROVINCE_PLACEHOLDER' | translate }}</option>
                  <option *ngFor="let region of regionList" [value]="region.id">
                    {{ region.name }}
                  </option>
                </select>
              </div>
            </form>
            <p *ngIf="isSubmit && !addressForm.get('region').value" class="font-sans text-alert text-s mt-4">
              {{ 'PROFILE_ADDRESS_FORM.REQUIRED_FIELD' | translate }}
            </p>
          </div>

          <div class="inp mb-16" *ngIf="townList.length > 0">
            <fun-input *ngIf="!isMobile" [placeholder]="'PROFILE_ADDRESS_FORM.STEP_2.CITY_PLACEHOLDER' | translate" [parentForm]="addressForm"
              [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit"
              controlName="city" type="select" [errorLogin]="errorAmount" [labelName]="'PROFILE_ADDRESS_FORM.STEP_2.CITY_LABEL' | translate" [items]="townList"
              (selectChange)="chdRef.detectChanges()" [selectedItem]="addressForm.get('city').value"></fun-input>
            <form *ngIf="isMobile" [formGroup]="addressForm">
              <div class="inp select form-input">
                <label class="block font-sans text-eggplant-80 text-l w-full mb-6">{{ 'PROFILE_ADDRESS_FORM.STEP_2.CITY_LABEL' | translate }}</label>
                <select
                  class="select-box w-full py-12 px-12 border border-eggplant-75 rounded bg-white font-sans text-eggplant-80"
                  formControlName="city">
                  <option hidden [value]="null">{{ 'PROFILE_ADDRESS_FORM.STEP_2.CITY_PLACEHOLDER' | translate }}</option>
                  <option *ngFor="let town of townList" [value]="town.id">
                    {{ town.name }}
                  </option>
                </select>
              </div>
            </form>
            <p *ngIf="isSubmit && !addressForm.get('city').value" class="font-sans text-alert text-s mt-4">
              {{ 'PROFILE_ADDRESS_FORM.REQUIRED_FIELD' | translate }}
            </p>
          </div>

          <div class="inp mb-16" *ngIf="townList.length === 0 && addressForm.get('region').value && !loading">
            <fun-input [placeholder]="'PROFILE_ADDRESS_FORM.STEP_2.CITY_LABEL' | translate" [parentForm]="addressForm" [formControlKeys]="formControlKeys"
              [errorMessages]="errorMessages" [isSubmit]="isSubmit" controlName="city" type="text"
              [errorLogin]="errorAmount" [labelName]="'PROFILE_ADDRESS_FORM.STEP_2.CITY_LABEL' | translate"></fun-input>
          </div>

          <p class="font-sans text-eggplant-100/[0.5] text-s mb-16">
            {{ 'PROFILE_ADDRESS_FORM.STEP_2.GOOGLE_HINT' | translate }}
            <span class="text-orange-100 cursor-pointer underline" (click)="switchAutocomplete(true)">{{ 'PROFILE_ADDRESS_FORM.STEP_2.CLICK_HERE' | translate }}</span>
          </p>
        </div>

        <!-- International: Region and City -->
        <div *ngIf="!isNationalResidence">
          <div class="inp mb-16">
            <fun-input [placeholder]="'PROFILE_ADDRESS_FORM.STEP_2.INTL_REGION_LABEL' | translate" [parentForm]="addressForm" [formControlKeys]="formControlKeys"
              [errorMessages]="errorMessages" [isSubmit]="isSubmit" controlName="internationalRegion" type="text"
              [errorLogin]="errorAmount" [labelName]="'PROFILE_ADDRESS_FORM.STEP_2.INTL_REGION_LABEL' | translate"></fun-input>
          </div>

          <div class="inp mb-16">
            <fun-input [placeholder]="'PROFILE_ADDRESS_FORM.STEP_2.INTL_CITY_LABEL' | translate" [parentForm]="addressForm" [formControlKeys]="formControlKeys"
              [errorMessages]="errorMessages" [isSubmit]="isSubmit" controlName="internationalCity" type="text"
              [errorLogin]="errorAmount" [labelName]="'PROFILE_ADDRESS_FORM.STEP_2.INTL_CITY_LABEL' | translate"></fun-input>
          </div>
        </div>
      </div>

      <!-- Loading ciudades -->
      <div *ngIf="loading" class="flex justify-center py-16">
        <fun-spinner></fun-spinner>
      </div>
    </div>
  </div>

  <!-- ==================== STEP 3: Declaración responsable ==================== -->
  <div *ngIf="step === 3" class="w-full">
    <div class="form-header header mb-24">
      <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px]">{{ 'PROFILE_ADDRESS_FORM.STEP_3.TITLE' | translate }}</h2>
      <p class="font-sans text-center text-xl text-gray-40">
        {{ 'PROFILE_ADDRESS_FORM.STEP_3.SUBTITLE' | translate }}
      </p>
    </div>

    <div class="form-body">
      <div class="legal-container bg-cream-100/[0.08] rounded-xl p-24 mb-24">
        <p class="font-sans text-eggplant-100 text-m mb-16">
          {{ 'PROFILE_ADDRESS_FORM.STEP_3.LEGAL_1' | translate }}
        </p>
        <p class="font-sans text-eggplant-100/[0.7] text-s mb-16">
          {{ 'PROFILE_ADDRESS_FORM.STEP_3.LEGAL_2' | translate }}
        </p>
        <p class="font-sans text-eggplant-100/[0.7] text-s">
          {{ 'PROFILE_ADDRESS_FORM.STEP_3.LEGAL_3' | translate }}
        </p>
      </div>

      <div class="form-input checkbox">
        <input type="checkbox" id="legalAcceptance" [checked]="legalAccepted" (change)="toggleLegal()">
        <label for="legalAcceptance" class="font-sans text-eggplant-100 text-m">
          {{ 'PROFILE_ADDRESS_FORM.STEP_3.DECLARATION' | translate }}
        </label>
      </div>
      <p *ngIf="legalError && !legalAccepted" class="font-sans text-alert text-s mt-4">
        {{ 'PROFILE_ADDRESS_FORM.STEP_3.DECLARATION_REQUIRED' | translate }}
      </p>
    </div>
  </div>

  <!-- ==================== STEP 4: Loader ==================== -->
  <div *ngIf="step === 4" class="w-full flex flex-col items-center justify-center py-64">
    <fun-spinner></fun-spinner>
    <p class="font-sans text-eggplant-100/[0.6] text-l mt-24">{{ 'PROFILE_ADDRESS_FORM.STEP_4.SAVING' | translate }}</p>
  </div>

  <!-- ==================== STEP 5: Resultado ==================== -->
  <div *ngIf="step === 5" class="w-full flex flex-col items-center justify-center py-48">
    <div class="w-64 h-64 rounded-full flex items-center justify-center mb-24">
      <fun-icon [name]="'check-circle'" [style]="'w-64 h-64 stroke-[2px] stroke-orange-100'"></fun-icon>
    </div>
    <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px]">{{ 'PROFILE_ADDRESS_FORM.STEP_5.TITLE' | translate }}</h2>
    <p class="font-sans text-center text-xl text-gray-40 mb-32">{{ successMessage }}</p>
    <fun-new-button [size]="'xl'" [buttonType]="'primaryDark'" (eventClick)="onCancel()" title="{{ 'PROFILE_ADDRESS_FORM.BTN.ACCEPT' | translate }}"
      [classExtra]="' !w-full max-w-[300px] '"></fun-new-button>
  </div>

  <!-- ==================== STEP 6: Error ==================== -->
  <div *ngIf="step === 6" class="w-full flex flex-col items-center justify-center py-48">
    <div class="w-64 h-64 rounded-full flex items-center justify-center mb-24">
      <fun-icon [name]="'user-x'" [style]="'w-64 h-64 stroke-[2px] stroke-orange-100'"></fun-icon>
    </div>
    <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px]">{{ 'PROFILE_ADDRESS_FORM.STEP_6.TITLE' | translate }}</h2>
    <p class="font-sans text-center text-xl text-gray-40 mb-32">{{ 'PROFILE_ADDRESS_FORM.STEP_6.ERROR_MSG' | translate }}</p>
    <fun-new-button [size]="'xl'" [buttonType]="'primaryDark'" (eventClick)="retryFromError()" title="{{ 'PROFILE_ADDRESS_FORM.BTN.RETRY' | translate }}"
      [classExtra]="' !w-full max-w-[300px] '"></fun-new-button>
  </div>

</div>

<!-- Footer -->
<div *ngIf="step <= 3"
  class="footer form-actions sticky bottom-0 bg-white p-24 border-t border-eggplant-100/[0.1] z-10 flex flex-col-reverse md:flex-row justify-between gap-12">

  <!-- Botón izquierdo: Cancelar (step 1) o Atrás (steps 2-3) -->
  <div class="w-full md:w-fit md:flex justify-center">
    <fun-new-button *ngIf="step === 1" [size]="'xl'" [buttonType]="'ghost'" (eventClick)="onCancel()" title="{{ 'PROFILE_ADDRESS_FORM.BTN.CANCEL' | translate }}"
      [classExtra]="' !w-full '"></fun-new-button>
    <fun-new-button *ngIf="step > 1" [size]="'xl'" [buttonType]="'ghost'" (eventClick)="prevStep()" title="{{ 'PROFILE_ADDRESS_FORM.BTN.BACK' | translate }}"
      [classExtra]="' !w-full '"></fun-new-button>
  </div>

  <!-- Botón derecho: Siguiente (steps 1-2) o Confirmar (step 3) -->
  <div class="w-full md:w-fit md:flex justify-center">
    <fun-new-button *ngIf="step === 1" [size]="'xl'" [buttonType]="isStep1Valid() ? 'primaryDark' : 'primaryDark-disabled'" (eventClick)="goToStep2()"
      title="{{ 'PROFILE_ADDRESS_FORM.BTN.NEXT' | translate }}" [classExtra]="' !w-full '"></fun-new-button>
    <fun-new-button *ngIf="step === 2" [size]="'xl'" [buttonType]="isStep2Valid() ? 'primaryDark' : 'primaryDark-disabled'" (eventClick)="goToStep3()"
      title="{{ 'PROFILE_ADDRESS_FORM.BTN.NEXT' | translate }}" [classExtra]="' !w-full '"></fun-new-button>
    <fun-new-button *ngIf="step === 3" [size]="'xl'" [buttonType]="legalAccepted ? 'primaryDark' : 'primaryDark-disabled'" (eventClick)="onSubmit()"
      title="{{ 'PROFILE_ADDRESS_FORM.BTN.CONFIRM' | translate }}" [classExtra]="' !w-full '"></fun-new-button>
  </div>
</div>
